import React, { Component } from "react";
import Details from "../../components/subscriptions/Details";
import PageHeader from "../../components/PageHeader";
import {
  Button,
  Confirm,
  Divider,
  Segment,
  Menu
} from "semantic-ui-react";
import ReactTable from "react-table";
import request from "../../utils/request";
import matchSorter from 'match-sorter';

// old version from legacy system. May be can remove ?
class Subscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      isLoading: true,
      sort: [{ id: "status", desc: false }, { id: "id", desc: false }],
      data: [],
      query: "",
      limit: 20,
      page: 1,
      total: 0,
      confirm: {
        open: false,
        id: 0,
        content: ""
      },
    };
  }
  componentDidMount = () => {
    this.setState({ isMounted: true });
    this.fetchData();
  };
  fetchData = e => {
    this.setState({ isLoading: true });
    request
      .get(this, "api:/subscriptions", {
        sort: this.state.sort,
        q: this.state.query,
        page: this.state.page,
        limit: this.state.limit
      })
      .then(resp => {
        this.setState({
          isLoading: false,
          data: resp.data,
          total: Math.ceil(resp.total / this.state.limit)
        });
      });
  };
  handleChange = (e, { name, value }) => {
    this.setState({ query: value });
  };
  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.fetchData();
    }
  };
  handleSearch = e => {
    this.setState({ page: 1 });
    setTimeout(this.fetchData, 200);
  };
  handlePaginationChange = (e, { activePage }) => {
    this.setState({ page: activePage });
    setTimeout(this.fetchData, 200);
  };
  handleSort = (newSorted, column, shiftKey) => {
    this.setState({ sort: newSorted });
  };
  startDelete = (e) => {
    this.setState({
      confirm: {
        open: true,
        id: e.currentTarget.dataset.id,
        content: e.currentTarget.dataset.message
      }
    });
  }
  cancelDelete = () => {
    this.setState({
      confirm: {
        open: false,
        id: 0,
        content: ""
      }
    });
  }
  confirmDelete = () => {
    const { confirm } = this.state;
    return request.delete(this, `api:/subscriptions/${confirm.id}`)
      .then(resp => {
        this.setState({
          confirm: {
            open: false,
            id: 0,
            content: ""
          }
        }, this.fetchData);
      });
  }
  render() {
    const {
      confirm,
      data,
      limit,
      isLoading
    } = this.state;
    const columns = [
      {
        accessor: d => (
          <Button icon="trash" color="red" data-id={d.id} data-message={`Are you sure you want to delete this subscription?`} onClick={this.startDelete} />
        ),
        id: "action",
        Header: "Action",
        sortable: false,
        filterable: false
      },
      {
        id: "id",
        accessor: "id",
        Header: "ID",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["id"] }),
        filterAll: true
      },
      {        
        accessor: d => d.events[0] ? d.events[0].title : "",
        id: "eventTitle",
        Header: "Event",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["eventTitle"] }),
        filterAll: true
      },
      {
        accessor: d => (d.details.envelope),
        Header: "Envelope",
        id: "envelope",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["envelope"] }),
        filterAll: true
      },
      {
        accessor: d => (d.details.orderdata.email),
        Header: "Email",
        id: "email",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["email"] }),
        filterAll: true
      },
      {        
        accessor: d => (d.details.orderdata.first_name),
        Header: "First Name",
        id: "firstName",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["firstName"] }),
        filterAll: true
      },
      {        
        accessor: d => (d.details.orderdata.last_name),
        Header: "Last Name",
        id: "lastName",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["lastName"] }),
        filterAll: true
      },
      {
        accessor: "details.totalcost",
        Header: "Cost",
        Cell: props => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(props.value),
        filterable: false
      },
      {
        accessor: "status",
        Header: "Status",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["status"] }),
        filterAll: true
      }
    ];

    return (
      <Segment basic loading={isLoading}>
        <PageHeader
          title={this.props.route.title}
          breadcrumbs={{
            key: "active",
            content: this.props.route.title,
            active: true
          }}
        />
        <Confirm
          open={confirm.open}
          content={confirm.content}
          cancelButton={confirm.id > 0 ? "Cancel" : "Close"}
          confirmButton={confirm.id > 0 ? "Confirm" : false}
          onCancel={this.cancelDelete}
          onConfirm={this.confirmDelete}
        />
        <Menu secondary stackable>
        </Menu>
        <Divider hidden />
        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight"
          loading={isLoading} // Display the loading overlay when we need it          
          resizable
          filterable
          defaultPageSize={limit}
          minRows={0}
          SubComponent={row => {
            if (row.original.orders)
              return false;
            return (
              <Details orders={row.original.orders} />
            );
          }}
        />
      </Segment>
    );
  }
}

export default Subscription;
